// import { KeycloakConfig } from 'keycloak-angular';

// Add here your keycloak setup infos
let keycloakConfig: Keycloak.KeycloakConfig = {
  url: 'https://accounts.accumn.ai',
  realm: 'corpository',
  clientId: 'gstin'
};

export const environment = {
    production: true,
    apiBaseURLGST: 'https://gst-api.corpository.com/corpository/v1',
    apiBaseURLInsight: 'https://web-api.accumn.ai/1.0',
    keycloakConfig: keycloakConfig,
    getBorrowerDetailsURL: '/getborrowerdetails?gstin_id='
};